import { Link } from "react-router-dom";

export function BrandMark({ to = "/" }: { to?: string }) {
  return <Link to={to} className="brand-mark" aria-label="FitYouX home">FitYouX</Link>;
}
